export const servicesEN = {
  // ── Services Hero ──────────────────────────────────────────────────
  'svc.heroLabel': 'PERCEPTYA AI VALUE SYSTEM™',
  'svc.heroHeadline': 'From AI {em}ambition{/em} to AI {em}value{/em}.',
  'svc.heroSub': "A structured, two-phase methodology designed for organizations serious about capturing economic value from AI. We don't run pilots — we build the foundation, prioritize by impact, and industrialize into production-grade systems that deliver measurable results.",
  'svc.heroBadge1': 'Phase 1 · AI Value Discovery · 6–10 Weeks',
  'svc.heroBadge2': 'Phase 2 · AI Industrialization · 3–12+ Months',

  // ── Phase 1 Section ────────────────────────────────────────────────
  'svc.p1Label': 'Phase 1',
  'svc.p1Headline': '{em}AI Value Discovery{/em}',
  'svc.p1Sub': '6–10 weeks of structured engagement that delivers executive clarity, a prioritized use case portfolio, architecture blueprint, and a board-ready roadmap backed by economic modeling. Every transformation starts here.',

  // Phase 1 steps (timeline)
  'svc.p1s1.title': 'Executive Alignment & Ambition',
  'svc.p1s1.timing': 'Week 1',
  'svc.p1s2.title': 'AI & Data Maturity Assessment',
  'svc.p1s2.timing': 'Weeks 2–4',
  'svc.p1s3.title': 'Use Case Identification & Prioritization',
  'svc.p1s3.timing': 'Weeks 4–6',
  'svc.p1s4.title': 'Target Architecture & Roadmap',
  'svc.p1s4.timing': 'Weeks 6–10',

  // Phase 1 bundle
  'svc.p1BundleLabel': 'Discovery Output Bundle',
  'svc.p1BundleTag1': 'AI Maturity Score',
  'svc.p1BundleTag2': 'Use Case Portfolio',
  'svc.p1BundleTag3': 'Architecture Blueprint',
  'svc.p1BundleTag4': '18–36 Mo Roadmap',
  'svc.p1BundleTag5': 'Financial Impact Model',

  // ── Common Frame Tags ──────────────────────────────────────────────
  'svc.frameInputs': 'Inputs',
  'svc.frameActivities': 'Key Activities',
  'svc.frameDeliverables': 'Key Deliverables',
  'svc.frameWhatYouGet': 'What You Get',
  'svc.frameInputsRequired': 'Inputs Required',

  // ── Step 01 Detail — Executive Alignment & Ambition ────────────────
  'svc.p1s1.tag': 'Step 01 · Week 1',
  'svc.p1s1.input1': 'C-suite and business leaders available for workshops',
  'svc.p1s1.input2': 'Overview of key business challenges and strategic priorities',
  'svc.p1s1.input3': 'Inventory of ongoing AI and data initiatives',
  'svc.p1s1.input4': 'Strategic priorities for the next 18–36 months',
  'svc.p1s1.act1': 'Executive alignment workshops with C-suite stakeholders',
  'svc.p1s1.act2': 'Value pool mapping across every business area',
  'svc.p1s1.act3': 'Target metrics and KPI definition tied to P&L',
  'svc.p1s1.act4': 'Governance principles establishment for AI initiatives',
  'svc.p1s1.del1': 'AI Ambition Statement aligned to corporate strategy',
  'svc.p1s1.del2': 'Value Pools Map by business area and function',
  'svc.p1s1.del3': 'Target Metrics Framework with baseline benchmarks',
  'svc.p1s1.del4': 'Governance Principles for AI decision-making',
  'svc.p1s1.value': 'Executive clarity before a single line of code.',
  'svc.p1s1.valueDesc': 'Your leadership team aligns on exactly where AI can move the P&L — not vague aspirations, but a focused mandate that drives every Discovery decision forward.',

  // ── Step 02 Detail — AI & Data Maturity Assessment ─────────────────
  'svc.p1s2.tag': 'Step 02 · Weeks 2–4',
  'svc.p1s2.input1': 'Access to data systems, technical stack and infrastructure',
  'svc.p1s2.input2': 'Data, engineering and analytics team leaders',
  'svc.p1s2.input3': 'Existing architecture documentation and data dictionaries',
  'svc.p1s2.input4': 'History of past data and AI initiatives and their outcomes',
  'svc.p1s2.act1': 'Comprehensive technical data and infrastructure assessment',
  'svc.p1s2.act2': 'Capability interviews across data, ML and engineering teams',
  'svc.p1s2.act3': 'Data quality audit and governance maturity evaluation',
  'svc.p1s2.act4': 'Gap analysis across 5 maturity dimensions with scoring',
  'svc.p1s2.del1': 'AI Maturity Score™ (0–5.0 per dimension)',
  'svc.p1s2.del2': 'Gap Analysis Report with remediation priorities',
  'svc.p1s2.del3': 'Capability Heatmap across teams and functions',
  'svc.p1s2.del4': 'Prioritized Pain Points linked to business impact',
  'svc.p1s2.value': 'An honest diagnosis — not a sales pitch.',
  'svc.p1s2.valueDesc': 'Your AI Maturity Score becomes the definitive baseline every future data and AI investment decision will reference.',

  // ── Step 03 Detail — Use Case Identification & Prioritization ──────
  'svc.p1s3.tag': 'Step 03 · Weeks 4–6',
  'svc.p1s3.input1': 'AI Maturity Score output and gap analysis findings',
  'svc.p1s3.input2': 'Business unit leaders across revenue and operations',
  'svc.p1s3.input3': 'P&L data by process, department and business area',
  'svc.p1s3.input4': 'Industry AI adoption benchmarks and competitive intelligence',
  'svc.p1s3.act1': 'Cross-functional use case ideation workshops',
  'svc.p1s3.act2': 'Financial impact modeling per candidate use case',
  'svc.p1s3.act3': 'Technical feasibility and data readiness scoring',
  'svc.p1s3.act4': 'Quick wins vs. strategic bets classification',
  'svc.p1s3.del1': 'Full Use Case Portfolio (20–30 candidates identified)',
  'svc.p1s3.del2': 'Impact × Feasibility Prioritization Matrix',
  'svc.p1s3.del3': 'Detailed Business Cases for Top 5–10 use cases',
  'svc.p1s3.del4': 'Quick Win Roadmap for immediate value capture',
  'svc.p1s3.value': 'A ranked portfolio of AI bets by real economic impact',
  'svc.p1s3.valueDesc': "— not what's technically interesting, but what moves the needle for your business.",

  // ── Step 04 Detail — Target Architecture & Roadmap ─────────────────
  'svc.p1s4.tag': 'Step 04 · Weeks 6–10',
  'svc.p1s4.input1': 'Prioritized use cases with validated business cases',
  'svc.p1s4.input2': 'Current technology stack and infrastructure landscape',
  'svc.p1s4.input3': 'Budget parameters and investment appetite',
  'svc.p1s4.input4': 'Regulatory, compliance and security constraints',
  'svc.p1s4.act1': 'Target architecture design across data, ML and AI layers',
  'svc.p1s4.act2': 'Technology evaluation, selection and vendor mapping',
  'svc.p1s4.act3': 'Phase sequencing with dependency and risk analysis',
  'svc.p1s4.act4': 'Investment vs. return modeling over 18–36 months',
  'svc.p1s4.del1': 'Architecture Blueprint (data + AI + agent layers)',
  'svc.p1s4.del2': '18–36 Month Roadmap — sequenced, costed, board-ready',
  'svc.p1s4.del3': 'Financial Impact Model with ROI projections',
  'svc.p1s4.del4': 'Industrialization Plan for Phase 2 execution',
  'svc.p1s4.value': 'A board-ready plan with the numbers behind it.',
  'svc.p1s4.valueDesc': 'Your team knows exactly what to build, in what order, and what returns to expect — ready for executive approval.',

  // ── Phase 2 Section ────────────────────────────────────────────────
  'svc.p2Label': 'Phase 2',
  'svc.p2Headline': '{em}AI Industrialization{/em} & Value Capture',
  'svc.p2Sub': 'Modular execution across 5 workstreams, sequenced by Discovery findings. Each module is designed for production from day one — with governance, monitoring, adoption, and continuous ROI tracking built in.',

  // Phase 2 module titles & timings
  'svc.p2sa.title': 'Data Foundation Modernization',
  'svc.p2sa.timing': 'Lakehouse · Pipelines · Governance',
  'svc.p2sb.title': 'Priority Use Case Implementation',
  'svc.p2sb.timing': 'MLOps · Production · Adoption',
  'svc.p2sc.title': 'Agent Architecture Deployment',
  'svc.p2sc.timing': 'Orchestration · Guardrails · Integration',
  'svc.p2sd.title': 'AI Operating Model & Governance',
  'svc.p2sd.timing': 'CoE · RACI · Policies · Compliance',
  'svc.p2se.title': 'ROI & Value Tracking',
  'svc.p2se.timing': 'Dashboards · Scorecards · Evidence',

  // ── Module A Detail — Data Foundation Modernization ─────────────────
  'svc.p2sa.tag': 'Module A',
  'svc.p2sa.input1': 'Architecture Blueprint from Discovery phase',
  'svc.p2sa.input2': 'Current data infrastructure inventory and access credentials',
  'svc.p2sa.input3': 'Data quality findings from AI Maturity Assessment',
  'svc.p2sa.input4': 'Compliance and regulatory data requirements',
  'svc.p2sa.act1': 'Lakehouse architecture design and implementation',
  'svc.p2sa.act2': 'Data pipeline engineering and orchestration setup',
  'svc.p2sa.act3': 'Data governance framework deployment with quality rules',
  'svc.p2sa.act4': 'Master data management and cataloging implementation',
  'svc.p2sa.del1': 'Production-ready data lakehouse platform',
  'svc.p2sa.del2': 'Automated data pipelines with monitoring and alerting',
  'svc.p2sa.del3': 'Data governance framework with quality scorecards',
  'svc.p2sa.del4': 'Data catalog with lineage and access controls',
  'svc.p2sa.value': 'A governed data foundation that makes AI possible.',
  'svc.p2sa.valueDesc': 'Your data becomes a trusted, accessible asset — the foundation every AI model, agent, and analytics system depends on.',

  // ── Module B Detail — Priority Use Case Implementation ─────────────
  'svc.p2sb.tag': 'Module B',
  'svc.p2sb.input1': 'Prioritized use cases with validated business cases from Discovery',
  'svc.p2sb.input2': 'Data foundation and pipelines from Module A',
  'svc.p2sb.input3': 'Domain experts and business stakeholders for validation',
  'svc.p2sb.input4': 'User acceptance criteria and success metrics',
  'svc.p2sb.act1': 'ML model development, training and validation cycles',
  'svc.p2sb.act2': 'MLOps pipeline setup for CI/CD and model versioning',
  'svc.p2sb.act3': 'Production deployment with monitoring and drift detection',
  'svc.p2sb.act4': 'User adoption programs with training and feedback loops',
  'svc.p2sb.del1': 'Production-deployed AI models with SLA guarantees',
  'svc.p2sb.del2': 'MLOps platform with automated retraining pipelines',
  'svc.p2sb.del3': 'Model monitoring dashboards with drift and performance alerts',
  'svc.p2sb.del4': 'User adoption playbook with training materials',
  'svc.p2sb.value': 'AI in production — not in a notebook.',
  'svc.p2sb.valueDesc': 'Your highest-impact use cases go live with enterprise-grade reliability, monitoring, and adoption built in from day one.',

  // ── Module C Detail — Agent Architecture Deployment ─────────────────
  'svc.p2sc.tag': 'Module C',
  'svc.p2sc.input1': 'Use case requirements that demand autonomous or semi-autonomous AI',
  'svc.p2sc.input2': 'Enterprise systems and APIs for agent integration',
  'svc.p2sc.input3': 'Security policies and guardrail requirements',
  'svc.p2sc.input4': 'User workflows and escalation protocols',
  'svc.p2sc.act1': 'Agent orchestration framework design and implementation',
  'svc.p2sc.act2': 'Guardrail systems with safety boundaries and fallbacks',
  'svc.p2sc.act3': 'Enterprise system integration and API connectivity',
  'svc.p2sc.act4': 'Human-in-the-loop workflows and escalation design',
  'svc.p2sc.del1': 'Deployed AI agents with orchestration layer',
  'svc.p2sc.del2': 'Guardrail framework with safety testing documentation',
  'svc.p2sc.del3': 'Integration connectors to enterprise systems',
  'svc.p2sc.del4': 'Escalation protocols and human oversight dashboards',
  'svc.p2sc.value': 'AI agents that act — within safe, governed boundaries.',
  'svc.p2sc.valueDesc': 'Your organization deploys autonomous AI with the guardrails, integrations, and human oversight that enterprise operations demand.',

  // ── Module D Detail — AI Operating Model & Governance ──────────────
  'svc.p2sd.tag': 'Module D',
  'svc.p2sd.input1': 'Governance principles from Discovery phase',
  'svc.p2sd.input2': 'Organizational structure and existing CoE capabilities',
  'svc.p2sd.input3': 'Regulatory landscape and compliance requirements',
  'svc.p2sd.input4': 'Risk management framework and audit requirements',
  'svc.p2sd.act1': 'AI Center of Excellence design and team structuring',
  'svc.p2sd.act2': 'RACI matrices and accountability frameworks for AI initiatives',
  'svc.p2sd.act3': 'AI policy development covering ethics, bias, and transparency',
  'svc.p2sd.act4': 'Compliance integration with regulatory and audit processes',
  'svc.p2sd.del1': 'AI Center of Excellence operational framework',
  'svc.p2sd.del2': 'RACI matrices for all AI initiatives and workstreams',
  'svc.p2sd.del3': 'AI policy handbook covering ethics, risk, and compliance',
  'svc.p2sd.del4': 'Audit-ready documentation and compliance checklists',
  'svc.p2sd.value': 'The organizational muscle to sustain AI at scale.',
  'svc.p2sd.valueDesc': 'Your AI program has the governance, accountability, and compliance structures that turn individual projects into a lasting enterprise capability.',

  // ── Module E Detail — ROI & Value Tracking ─────────────────────────
  'svc.p2se.tag': 'Module E',
  'svc.p2se.input1': 'Financial Impact Model from Discovery phase',
  'svc.p2se.input2': 'Production AI systems with telemetry data',
  'svc.p2se.input3': 'Business KPIs and baseline benchmarks',
  'svc.p2se.input4': 'Stakeholder reporting requirements and cadences',
  'svc.p2se.act1': 'ROI dashboard design and data integration',
  'svc.p2se.act2': 'Value scorecard development per use case and business unit',
  'svc.p2se.act3': 'Evidence-based reporting framework for executive reviews',
  'svc.p2se.act4': 'Continuous improvement cycles driven by value data',
  'svc.p2se.del1': 'Live ROI dashboards with real-time value tracking',
  'svc.p2se.del2': 'Value scorecards per use case with evidence trails',
  'svc.p2se.del3': 'Executive reporting package with board-ready summaries',
  'svc.p2se.del4': 'Continuous improvement recommendations based on value data',
  'svc.p2se.value': 'Proof that AI delivers — in numbers, not narratives.',
  'svc.p2se.valueDesc': 'Every AI investment is tracked, measured, and reported with the rigor your board and stakeholders expect.',

  // ── Phase 2 Bundle ─────────────────────────────────────────────────
  'svc.p2BundleLabel': 'Industrialization Outcomes',
  'svc.p2BundleTag1': 'Production AI Systems',
  'svc.p2BundleTag2': 'Agent Deployments',
  'svc.p2BundleTag3': 'Governed Data Platform',
  'svc.p2BundleTag4': 'ROI Dashboards',
  'svc.p2BundleTag5': 'Operating Model',

  // ── Engagement Model Section ───────────────────────────────────────
  'svc.engLabel': 'How We Engage',
  'svc.engHeadline': 'Three ways to work with us.',
  'svc.engSub': 'Every engagement is structured for clarity, accountability, and measurable outcomes. Choose the model that fits your stage.',

  // Engagement 1 — AI Value Discovery
  'svc.eng1Badge': 'AI Value Discovery',
  'svc.eng1Title': 'Executive Clarity',
  'svc.eng1Body': 'Fixed scope, 6–10 weeks. The starting point for every engagement. Delivers AI Maturity Score, prioritized use cases, architecture blueprint, and a board-ready roadmap with financial impact model.',
  'svc.eng1Meta1': 'Fixed Scope',
  'svc.eng1Meta2': '6–10 Weeks',
  'svc.eng1Meta3': '5 Deliverables',

  // Engagement 2 — AI Industrialization
  'svc.eng2Badge': 'AI Industrialization',
  'svc.eng2Title': 'Production AI',
  'svc.eng2Body': 'Modular execution, 3–12+ months. Sequenced by Discovery findings. Data foundation, use case implementation, agent architecture, governance, and ROI tracking — all built for production.',
  'svc.eng2Meta1': 'Modular',
  'svc.eng2Meta2': '3–12+ Months',
  'svc.eng2Meta3': 'Production Ready',

  // Engagement 3 — Dedicated PODs
  'svc.eng3Badge': 'Dedicated PODs',
  'svc.eng3Title': 'Scale & Velocity',
  'svc.eng3Body': 'Dedicated PODs. Senior, timezone-aligned, tech-agnostic. Monthly engagement designed for organizations that need sustained execution capacity and embedded AI engineering talent.',
  'svc.eng3Meta1': 'Onshore and Nearshore',
  'svc.eng3Meta2': 'Monthly',
  'svc.eng3Meta3': 'Senior PODs',

  'svc.engCta': 'Start with AI Value Discovery',

  // ── Why AI Stalls Section ──────────────────────────────────────────
  'svc.stallLabel': 'Why AI Initiatives Stall',
  'svc.stallHeadline': 'Most organizations have the {em}ambition{/em}. Few have the {em}foundation{/em}.',
  'svc.stallSub': "The challenge isn't access to AI tools — it's what comes before. Research consistently shows the same four root causes blocking enterprise AI from delivering value. We built our methodology to solve each one.",

  // Stall card column labels
  'svc.stallImplications': 'Business Implications',
  'svc.stallLooksLike': 'What This Looks Like',
  'svc.stallResearch': 'Research',

  // Stall card 1
  'svc.stall1.title': 'Fragmented Data',
  'svc.stall1.desc': 'Siloed systems, no single source of truth, and data quality issues that block AI at every step. When AI models train on inconsistent, incomplete, or ungoverned data, the outputs are unreliable — and executives lose trust in the entire program.',

  // Stall card 2
  'svc.stall2.title': 'Pilots That Never Scale',
  'svc.stall2.desc': 'POCs that prove a point but never reach production. Organizations launch proof-of-concepts in safe sandboxes, but integration, governance, MLOps, and user adoption challenges mean they stall at the demo stage — forever.',

  // Stall card 3
  'svc.stall3.title': 'No Economic Thesis',
  'svc.stall3.desc': 'AI initiatives disconnected from revenue, margin, or measurable business outcomes. Without a clear financial model from day one, projects compete for budget with no way to prove their value — and lose every time budgets tighten.',

  // Stall card 4
  'svc.stall4.title': 'Capability & Adoption Gaps',
  'svc.stall4.desc': 'Technical execution without change management, governance structures, or user adoption strategy. Organizations invest in models and infrastructure but forget that AI only creates value when people actually use it — and when the organization is structured to sustain it.',

  // ── MethodologyPipeline (Home page) ────────────────────────────────
  'meth.label': 'Our Methodology',
  'meth.headline': 'A structured path from {em}data chaos{/em} to AI that earns its place on the P&L.',
  'meth.sub': "The PERCEPTYA AI VALUE SYSTEM™ is not a framework we adapt — it's a methodology built for one purpose: capturing real economic value from AI in production.",
  'meth.ph1Badge': 'PHASE 1',
  'meth.ph1Label': 'AI Value Discovery',
  'meth.ph1Dur': '6–10 Weeks · Fixed Scope',
  'meth.ph2Badge': 'PHASE 2',
  'meth.ph2Label': 'AI Industrialization & Value Capture',
  'meth.ph2Dur': 'Modular · 3–12+ Months',
  'meth.cta': 'Explore the full methodology',
  'meth.explorePhase': 'Explore this phase in detail',
  'meth.exploreModule': 'Explore this module in detail',
  'meth.deliverableCaption': 'Deliverable example',
  // Node labels
  'meth.p1n1.label': 'Executive Alignment & Ambition',
  'meth.p1n2.label': 'AI & Data Maturity Assessment',
  'meth.p1n3.label': 'Use Case Identification & Prioritization',
  'meth.p1n4.label': 'Target Architecture & Roadmap',
  'meth.p2na.label': 'Data Foundation Modernization',
  'meth.p2nb.label': 'Priority Use Case Implementation',
  'meth.p2nc.label': 'Agent Architecture Deployment',
  'meth.p2nd.label': 'AI Operating Model & Governance',
  'meth.p2ne.label': 'ROI & Value Tracking',
  // Panel phase tags
  'meth.p1n1.phaseTag': 'Phase 1 · Step 01',
  'meth.p1n2.phaseTag': 'Phase 1 · Step 02',
  'meth.p1n3.phaseTag': 'Phase 1 · Step 03',
  'meth.p1n4.phaseTag': 'Phase 1 · Step 04',
  'meth.p2na.phaseTag': 'Phase 2 · Module A',
  'meth.p2nb.phaseTag': 'Phase 2 · Module B',
  'meth.p2nc.phaseTag': 'Phase 2 · Module C',
  'meth.p2nd.phaseTag': 'Phase 2 · Module D',
  'meth.p2ne.phaseTag': 'Phase 2 · Module E',
  // Panel CTA texts
  'meth.p1n1.cta': 'Week 1 of Discovery. The starting point for every transformation that delivers real results.',
  'meth.p1n2.cta': 'Weeks 2–4. The benchmark that makes every future decision defensible.',
  'meth.p1n3.cta': 'Weeks 4–6. From 23 candidates to a portfolio of 7 use cases with approved business cases.',
  'meth.p1n4.cta': 'Weeks 6–10. The output that turns AI into a revenue line, not a cost line.',
  'meth.p2na.cta': "Module A. The foundation that enables every other module. Without it, AI doesn't scale.",
  'meth.p2nb.cta': 'Module B. AI that delivers results from the first sprint — with numbers to defend to the board.',
  'meth.p2nc.cta': 'Module C. Agents built to operate — not to impress in demos.',
  'meth.p2nd.cta': 'Module D. Without governance, AI becomes a liability. With it, a competitive advantage.',
  'meth.p2ne.cta': 'Module E. The only module that runs in parallel with every other — from day one to the last.',
  // Panel "What You Get" values (bold portion + description)
  'meth.p1n1.valueTitle': 'Executive clarity before a single line of code.',
  'meth.p1n1.valueDesc': "Know exactly where AI can move your P&L — not vague aspirations, but a focused mandate that drives every Discovery decision.",
  'meth.p1n2.valueTitle': 'An honest diagnosis — not a sales pitch.',
  'meth.p1n2.valueDesc': 'Your AI Maturity Score becomes the map every future data and AI investment will follow.',
  'meth.p1n3.valueTitle': 'A ranked list of AI bets by real economic impact',
  'meth.p1n3.valueDesc': "— not what's technically interesting, but what moves the needle for your business.",
  'meth.p1n4.valueTitle': 'A board-ready plan with the numbers behind it.',
  'meth.p1n4.valueDesc': 'Your team knows exactly what to build, in what order, and what returns to expect — ready for executive approval.',
  'meth.p2na.valueTitle': 'AI that works requires data that flows.',
  'meth.p2na.valueDesc': 'We build the foundation every use case depends on — reliable, traceable, and ready to scale.',
  'meth.p2nb.valueTitle': 'Not demos. Production systems.',
  'meth.p2nb.valueDesc': 'Revenue, margin and efficiency gains you can measure and report to the board — every sprint.',
  'meth.p2nc.valueTitle': 'Intelligent automation that operates at scale.',
  'meth.p2nc.valueDesc': 'Agents that make decisions, execute workflows and serve customers — without human bottlenecks, with full traceability.',
  'meth.p2nd.valueTitle': "AI that doesn't get blocked by the organization.",
  'meth.p2nd.valueDesc': 'Governance designed to accelerate — not to create bureaucracy. Your team knows who decides, who executes, and who is accountable.',
  'meth.p2ne.valueTitle': 'Proof. Every initiative tied to a number.',
  'meth.p2ne.valueDesc': 'Revenue uplift, cost reduction, productivity gain — tracked, attributed and reportable. No guesswork.',
} as const;

export const servicesPT = {
  // ── Services Hero ──────────────────────────────────────────────────
  'svc.heroLabel': 'PERCEPTYA AI VALUE SYSTEM™',
  'svc.heroHeadline': 'Da {em}ambição{/em} de IA ao {em}valor{/em} de IA.',
  'svc.heroSub': 'Uma metodologia estruturada em duas fases, projetada para organizações sérias sobre capturar valor econômico da IA. Não executamos pilotos — construímos a fundação, priorizamos por impacto e industrializamos em sistemas de nível de produção que entregam resultados mensuráveis.',
  'svc.heroBadge1': 'Fase 1 · AI Value Discovery · 6–10 Semanas',
  'svc.heroBadge2': 'Fase 2 · Industrialização de IA · 3–12+ Meses',

  // ── Phase 1 Section ────────────────────────────────────────────────
  'svc.p1Label': 'Fase 1',
  'svc.p1Headline': '{em}AI Value Discovery{/em}',
  'svc.p1Sub': '6–10 semanas de engajamento estruturado que entrega clareza executiva, um portfólio priorizado de casos de uso, blueprint de arquitetura e um roadmap pronto para o conselho respaldado por modelagem econômica. Toda transformação começa aqui.',

  // Phase 1 steps (timeline)
  'svc.p1s1.title': 'Alinhamento Executivo & Ambição',
  'svc.p1s1.timing': 'Semana 1',
  'svc.p1s2.title': 'Avaliação de Maturidade de IA & Dados',
  'svc.p1s2.timing': 'Semanas 2–4',
  'svc.p1s3.title': 'Identificação & Priorização de Casos de Uso',
  'svc.p1s3.timing': 'Semanas 4–6',
  'svc.p1s4.title': 'Arquitetura-Alvo & Roadmap',
  'svc.p1s4.timing': 'Semanas 6–10',

  // Phase 1 bundle
  'svc.p1BundleLabel': 'Pacote de Entregas do Discovery',
  'svc.p1BundleTag1': 'AI Maturity Score',
  'svc.p1BundleTag2': 'Portfólio de Casos de Uso',
  'svc.p1BundleTag3': 'Architecture Blueprint',
  'svc.p1BundleTag4': 'Roadmap 18–36 Meses',
  'svc.p1BundleTag5': 'Financial Impact Model',

  // ── Common Frame Tags ──────────────────────────────────────────────
  'svc.frameInputs': 'Entradas',
  'svc.frameActivities': 'Atividades Principais',
  'svc.frameDeliverables': 'Entregas Principais',
  'svc.frameWhatYouGet': 'O Que Você Recebe',
  'svc.frameInputsRequired': 'Entradas Necessárias',

  // ── Step 01 Detail — Alinhamento Executivo & Ambição ───────────────
  'svc.p1s1.tag': 'Passo 01 · Semana 1',
  'svc.p1s1.input1': 'C-level e líderes de negócio disponíveis para workshops',
  'svc.p1s1.input2': 'Visão geral dos principais desafios de negócio e prioridades estratégicas',
  'svc.p1s1.input3': 'Inventário de iniciativas de IA e dados em andamento',
  'svc.p1s1.input4': 'Prioridades estratégicas para os próximos 18–36 meses',
  'svc.p1s1.act1': 'Workshops de alinhamento executivo com stakeholders C-level',
  'svc.p1s1.act2': 'Mapeamento de pools de valor em todas as áreas de negócio',
  'svc.p1s1.act3': 'Definição de métricas-alvo e KPIs vinculados ao P&L',
  'svc.p1s1.act4': 'Estabelecimento de princípios de governança para iniciativas de IA',
  'svc.p1s1.del1': 'AI Ambition Statement alinhado à estratégia corporativa',
  'svc.p1s1.del2': 'Value Pools Map por área de negócio e função',
  'svc.p1s1.del3': 'Target Metrics Framework com benchmarks de baseline',
  'svc.p1s1.del4': 'Princípios de Governança para decisões de IA',
  'svc.p1s1.value': 'Clareza executiva antes de uma única linha de código.',
  'svc.p1s1.valueDesc': 'Sua liderança se alinha exatamente em onde a IA pode mover o P&L — não aspirações vagas, mas um mandato focado que impulsiona cada decisão do Discovery.',

  // ── Step 02 Detail — Avaliação de Maturidade de IA & Dados ─────────
  'svc.p1s2.tag': 'Passo 02 · Semanas 2–4',
  'svc.p1s2.input1': 'Acesso a sistemas de dados, stack técnico e infraestrutura',
  'svc.p1s2.input2': 'Líderes das equipes de dados, engenharia e analytics',
  'svc.p1s2.input3': 'Documentação de arquitetura existente e dicionários de dados',
  'svc.p1s2.input4': 'Histórico de iniciativas passadas de dados e IA e seus resultados',
  'svc.p1s2.act1': 'Avaliação técnica abrangente de dados e infraestrutura',
  'svc.p1s2.act2': 'Entrevistas de capacidade com equipes de dados, ML e engenharia',
  'svc.p1s2.act3': 'Auditoria de qualidade de dados e avaliação de maturidade de governança',
  'svc.p1s2.act4': 'Análise de gaps em 5 dimensões de maturidade com pontuação',
  'svc.p1s2.del1': 'AI Maturity Score™ (0–5.0 por dimensão)',
  'svc.p1s2.del2': 'Relatório de Análise de Gaps com prioridades de remediação',
  'svc.p1s2.del3': 'Mapa de Capacidades entre equipes e funções',
  'svc.p1s2.del4': 'Pontos de Dor Priorizados vinculados ao impacto no negócio',
  'svc.p1s2.value': 'Um diagnóstico honesto — não um discurso de vendas.',
  'svc.p1s2.valueDesc': 'Seu AI Maturity Score se torna a linha de base definitiva que toda futura decisão de investimento em dados e IA referenciará.',

  // ── Step 03 Detail — Identificação & Priorização de Casos de Uso ───
  'svc.p1s3.tag': 'Passo 03 · Semanas 4–6',
  'svc.p1s3.input1': 'Resultados do AI Maturity Score e análise de gaps',
  'svc.p1s3.input2': 'Líderes de unidades de negócio de receita e operações',
  'svc.p1s3.input3': 'Dados de P&L por processo, departamento e área de negócio',
  'svc.p1s3.input4': 'Benchmarks de adoção de IA na indústria e inteligência competitiva',
  'svc.p1s3.act1': 'Workshops multifuncionais de ideação de casos de uso',
  'svc.p1s3.act2': 'Modelagem de impacto financeiro por caso de uso candidato',
  'svc.p1s3.act3': 'Avaliação de viabilidade técnica e prontidão de dados',
  'svc.p1s3.act4': 'Classificação de quick wins vs. apostas estratégicas',
  'svc.p1s3.del1': 'Portfólio Completo de Casos de Uso (20–30 candidatos identificados)',
  'svc.p1s3.del2': 'Matriz de Priorização Impacto × Viabilidade',
  'svc.p1s3.del3': 'Business Cases Detalhados para os Top 5–10 casos de uso',
  'svc.p1s3.del4': 'Roadmap de Quick Wins para captura imediata de valor',
  'svc.p1s3.value': 'Um portfólio ranqueado de apostas de IA por impacto econômico real',
  'svc.p1s3.valueDesc': '— não o que é tecnicamente interessante, mas o que realmente move o ponteiro do seu negócio.',

  // ── Step 04 Detail — Arquitetura-Alvo & Roadmap ────────────────────
  'svc.p1s4.tag': 'Passo 04 · Semanas 6–10',
  'svc.p1s4.input1': 'Casos de uso priorizados com business cases validados',
  'svc.p1s4.input2': 'Stack tecnológico atual e panorama de infraestrutura',
  'svc.p1s4.input3': 'Parâmetros de orçamento e apetite de investimento',
  'svc.p1s4.input4': 'Restrições regulatórias, de compliance e segurança',
  'svc.p1s4.act1': 'Design de arquitetura-alvo nas camadas de dados, ML e IA',
  'svc.p1s4.act2': 'Avaliação de tecnologia, seleção e mapeamento de fornecedores',
  'svc.p1s4.act3': 'Sequenciamento de fases com análise de dependências e riscos',
  'svc.p1s4.act4': 'Modelagem de investimento vs. retorno ao longo de 18–36 meses',
  'svc.p1s4.del1': 'Architecture Blueprint (camadas de dados + IA + agentes)',
  'svc.p1s4.del2': 'Roadmap de 18–36 Meses — sequenciado, orçado, pronto para o conselho',
  'svc.p1s4.del3': 'Modelo de Impacto Financeiro com projeções de ROI',
  'svc.p1s4.del4': 'Plano de Industrialização para execução da Fase 2',
  'svc.p1s4.value': 'Um plano pronto para o conselho com os números por trás.',
  'svc.p1s4.valueDesc': 'Sua equipe sabe exatamente o que construir, em que ordem, e quais retornos esperar — pronto para aprovação executiva.',

  // ── Phase 2 Section ────────────────────────────────────────────────
  'svc.p2Label': 'Fase 2',
  'svc.p2Headline': '{em}Industrialização de IA{/em} & Captura de Valor',
  'svc.p2Sub': 'Execução modular em 5 frentes de trabalho, sequenciada pelas descobertas do Discovery. Cada módulo é projetado para produção desde o primeiro dia — com governança, monitoramento, adoção e rastreamento contínuo de ROI integrados.',

  // Phase 2 module titles & timings
  'svc.p2sa.title': 'Modernização da Fundação de Dados',
  'svc.p2sa.timing': 'Lakehouse · Pipelines · Governança',
  'svc.p2sb.title': 'Implementação de Casos de Uso Prioritários',
  'svc.p2sb.timing': 'MLOps · Produção · Adoção',
  'svc.p2sc.title': 'Deploy de Arquitetura de Agentes',
  'svc.p2sc.timing': 'Orquestração · Guardrails · Integração',
  'svc.p2sd.title': 'Modelo Operacional de IA & Governança',
  'svc.p2sd.timing': 'CoE · RACI · Políticas · Compliance',
  'svc.p2se.title': 'ROI & Rastreamento de Valor',
  'svc.p2se.timing': 'Dashboards · Scorecards · Evidências',

  // ── Module A Detail — Modernização da Fundação de Dados ────────────
  'svc.p2sa.tag': 'Módulo A',
  'svc.p2sa.input1': 'Architecture Blueprint da fase de Discovery',
  'svc.p2sa.input2': 'Inventário atual de infraestrutura de dados e credenciais de acesso',
  'svc.p2sa.input3': 'Achados de qualidade de dados da Avaliação de Maturidade de IA',
  'svc.p2sa.input4': 'Requisitos regulatórios e de compliance para dados',
  'svc.p2sa.act1': 'Design e implementação de arquitetura lakehouse',
  'svc.p2sa.act2': 'Engenharia de pipelines de dados e configuração de orquestração',
  'svc.p2sa.act3': 'Implantação do framework de governança de dados com regras de qualidade',
  'svc.p2sa.act4': 'Implementação de gestão de dados mestres e catalogação',
  'svc.p2sa.del1': 'Plataforma de data lakehouse pronta para produção',
  'svc.p2sa.del2': 'Pipelines de dados automatizados com monitoramento e alertas',
  'svc.p2sa.del3': 'Framework de governança de dados com scorecards de qualidade',
  'svc.p2sa.del4': 'Catálogo de dados com linhagem e controles de acesso',
  'svc.p2sa.value': 'Uma fundação de dados governada que viabiliza a IA.',
  'svc.p2sa.valueDesc': 'Seus dados se tornam um ativo confiável e acessível — a fundação da qual cada modelo de IA, agente e sistema de analytics depende.',

  // ── Module B Detail — Implementação de Casos de Uso Prioritários ───
  'svc.p2sb.tag': 'Módulo B',
  'svc.p2sb.input1': 'Casos de uso priorizados com business cases validados do Discovery',
  'svc.p2sb.input2': 'Fundação de dados e pipelines do Módulo A',
  'svc.p2sb.input3': 'Especialistas de domínio e stakeholders de negócio para validação',
  'svc.p2sb.input4': 'Critérios de aceite do usuário e métricas de sucesso',
  'svc.p2sb.act1': 'Desenvolvimento, treinamento e ciclos de validação de modelos de ML',
  'svc.p2sb.act2': 'Configuração de pipeline MLOps para CI/CD e versionamento de modelos',
  'svc.p2sb.act3': 'Deploy em produção com monitoramento e detecção de drift',
  'svc.p2sb.act4': 'Programas de adoção por usuários com treinamento e ciclos de feedback',
  'svc.p2sb.del1': 'Modelos de IA em produção com garantias de SLA',
  'svc.p2sb.del2': 'Plataforma MLOps com pipelines de retreinamento automatizado',
  'svc.p2sb.del3': 'Dashboards de monitoramento de modelos com alertas de drift e performance',
  'svc.p2sb.del4': 'Playbook de adoção por usuários com materiais de treinamento',
  'svc.p2sb.value': 'IA em produção — não em um notebook.',
  'svc.p2sb.valueDesc': 'Seus casos de uso de maior impacto entram em produção com confiabilidade enterprise, monitoramento e adoção integrados desde o primeiro dia.',

  // ── Module C Detail — Deploy de Arquitetura de Agentes ─────────────
  'svc.p2sc.tag': 'Módulo C',
  'svc.p2sc.input1': 'Requisitos de casos de uso que demandam IA autônoma ou semi-autônoma',
  'svc.p2sc.input2': 'Sistemas enterprise e APIs para integração de agentes',
  'svc.p2sc.input3': 'Políticas de segurança e requisitos de guardrails',
  'svc.p2sc.input4': 'Workflows de usuários e protocolos de escalonamento',
  'svc.p2sc.act1': 'Design e implementação do framework de orquestração de agentes',
  'svc.p2sc.act2': 'Sistemas de guardrails com limites de segurança e fallbacks',
  'svc.p2sc.act3': 'Integração com sistemas enterprise e conectividade de APIs',
  'svc.p2sc.act4': 'Workflows de human-in-the-loop e design de escalonamento',
  'svc.p2sc.del1': 'Agentes de IA deployados com camada de orquestração',
  'svc.p2sc.del2': 'Framework de guardrails com documentação de testes de segurança',
  'svc.p2sc.del3': 'Conectores de integração com sistemas enterprise',
  'svc.p2sc.del4': 'Protocolos de escalonamento e dashboards de supervisão humana',
  'svc.p2sc.value': 'Agentes de IA que agem — dentro de limites seguros e governados.',
  'svc.p2sc.valueDesc': 'Sua organização deploya IA autônoma com os guardrails, integrações e supervisão humana que operações enterprise exigem.',

  // ── Module D Detail — Modelo Operacional de IA & Governança ────────
  'svc.p2sd.tag': 'Módulo D',
  'svc.p2sd.input1': 'Princípios de governança da fase de Discovery',
  'svc.p2sd.input2': 'Estrutura organizacional e capacidades existentes de CoE',
  'svc.p2sd.input3': 'Panorama regulatório e requisitos de compliance',
  'svc.p2sd.input4': 'Framework de gestão de riscos e requisitos de auditoria',
  'svc.p2sd.act1': 'Design do Centro de Excelência de IA e estruturação de equipe',
  'svc.p2sd.act2': 'Matrizes RACI e frameworks de responsabilidade para iniciativas de IA',
  'svc.p2sd.act3': 'Desenvolvimento de políticas de IA cobrindo ética, viés e transparência',
  'svc.p2sd.act4': 'Integração de compliance com processos regulatórios e de auditoria',
  'svc.p2sd.del1': 'Framework operacional do Centro de Excelência de IA',
  'svc.p2sd.del2': 'Matrizes RACI para todas as iniciativas e frentes de trabalho de IA',
  'svc.p2sd.del3': 'Manual de políticas de IA cobrindo ética, risco e compliance',
  'svc.p2sd.del4': 'Documentação pronta para auditoria e checklists de compliance',
  'svc.p2sd.value': 'O músculo organizacional para sustentar IA em escala.',
  'svc.p2sd.valueDesc': 'Seu programa de IA tem as estruturas de governança, responsabilidade e compliance que transformam projetos individuais em uma capacidade enterprise duradoura.',

  // ── Module E Detail — ROI & Rastreamento de Valor ──────────────────
  'svc.p2se.tag': 'Módulo E',
  'svc.p2se.input1': 'Modelo de Impacto Financeiro da fase de Discovery',
  'svc.p2se.input2': 'Sistemas de IA em produção com dados de telemetria',
  'svc.p2se.input3': 'KPIs de negócio e benchmarks de baseline',
  'svc.p2se.input4': 'Requisitos e cadências de reporte para stakeholders',
  'svc.p2se.act1': 'Design de dashboard de ROI e integração de dados',
  'svc.p2se.act2': 'Desenvolvimento de scorecards de valor por caso de uso e unidade de negócio',
  'svc.p2se.act3': 'Framework de reporte baseado em evidências para revisões executivas',
  'svc.p2se.act4': 'Ciclos de melhoria contínua orientados por dados de valor',
  'svc.p2se.del1': 'Dashboards de ROI ao vivo com rastreamento de valor em tempo real',
  'svc.p2se.del2': 'Scorecards de valor por caso de uso com trilhas de evidências',
  'svc.p2se.del3': 'Pacote de reporte executivo com sumários prontos para o conselho',
  'svc.p2se.del4': 'Recomendações de melhoria contínua baseadas em dados de valor',
  'svc.p2se.value': 'Prova de que a IA entrega — em números, não em narrativas.',
  'svc.p2se.valueDesc': 'Cada investimento em IA é rastreado, medido e reportado com o rigor que seu conselho e stakeholders esperam.',

  // ── Phase 2 Bundle ─────────────────────────────────────────────────
  'svc.p2BundleLabel': 'Resultados da Industrialização',
  'svc.p2BundleTag1': 'Sistemas de IA em Produção',
  'svc.p2BundleTag2': 'Deploy de Agentes',
  'svc.p2BundleTag3': 'Plataforma de Dados Governada',
  'svc.p2BundleTag4': 'Dashboards de ROI',
  'svc.p2BundleTag5': 'Modelo Operacional',

  // ── Engagement Model Section ───────────────────────────────────────
  'svc.engLabel': 'Como Trabalhamos',
  'svc.engHeadline': 'Três formas de trabalhar conosco.',
  'svc.engSub': 'Cada engajamento é estruturado para clareza, responsabilidade e resultados mensuráveis. Escolha o modelo que se encaixa no seu estágio.',

  // Engagement 1 — AI Value Discovery
  'svc.eng1Badge': 'AI Value Discovery',
  'svc.eng1Title': 'Clareza Executiva',
  'svc.eng1Body': 'Escopo fixo, 6–10 semanas. O ponto de partida para cada engajamento. Entrega AI Maturity Score, casos de uso priorizados, blueprint de arquitetura e um roadmap pronto para o conselho com modelo de impacto financeiro.',
  'svc.eng1Meta1': 'Escopo Fixo',
  'svc.eng1Meta2': '6–10 Semanas',
  'svc.eng1Meta3': '5 Entregáveis',

  // Engagement 2 — AI Industrialization
  'svc.eng2Badge': 'Industrialização de IA',
  'svc.eng2Title': 'IA em Produção',
  'svc.eng2Body': 'Execução modular, 3–12+ meses. Sequenciada pelas descobertas do Discovery. Fundação de dados, implementação de casos de uso, arquitetura de agentes, governança e rastreamento de ROI — tudo construído para produção.',
  'svc.eng2Meta1': 'Modular',
  'svc.eng2Meta2': '3–12+ Meses',
  'svc.eng2Meta3': 'Pronto para Produção',

  // Engagement 3 — Dedicated PODs
  'svc.eng3Badge': 'PODs Dedicados',
  'svc.eng3Title': 'Escala & Velocidade',
  'svc.eng3Body': 'PODs dedicados. Seniores, alinhados por timezone, tech-agnostic. Engajamento mensal projetado para organizações que precisam de capacidade de execução sustentada e talento de engenharia de IA embarcado.',
  'svc.eng3Meta1': 'Onshore e Nearshore',
  'svc.eng3Meta2': 'Mensal',
  'svc.eng3Meta3': 'PODs Seniores',

  'svc.engCta': 'Comece com AI Value Discovery',

  // ── Why AI Stalls Section ──────────────────────────────────────────
  'svc.stallLabel': 'Por Que Iniciativas de IA Estagnam',
  'svc.stallHeadline': 'A maioria das organizações tem a {em}ambição{/em}. Poucas têm a {em}fundação{/em}.',
  'svc.stallSub': 'O desafio não é acesso a ferramentas de IA — é o que vem antes. Pesquisas consistentemente mostram as mesmas quatro causas-raiz bloqueando a IA empresarial de entregar valor. Construímos nossa metodologia para resolver cada uma.',

  // Stall card column labels
  'svc.stallImplications': 'Implicações para o Negócio',
  'svc.stallLooksLike': 'Como Isso Se Manifesta',
  'svc.stallResearch': 'Pesquisa',

  // Stall card 1
  'svc.stall1.title': 'Dados Fragmentados',
  'svc.stall1.desc': 'Sistemas isolados, sem fonte única de verdade, e problemas de qualidade de dados que bloqueiam a IA em cada etapa. Quando modelos de IA treinam com dados inconsistentes, incompletos ou não governados, os outputs são não confiáveis — e executivos perdem confiança no programa inteiro.',

  // Stall card 2
  'svc.stall2.title': 'Pilotos Que Nunca Escalam',
  'svc.stall2.desc': 'POCs que provam um ponto mas nunca chegam à produção. Organizações lançam provas de conceito em sandboxes seguros, mas desafios de integração, governança, MLOps e adoção pelos usuários significam que estagnam na fase de demo — para sempre.',

  // Stall card 3
  'svc.stall3.title': 'Sem Tese Econômica',
  'svc.stall3.desc': 'Iniciativas de IA desconectadas de receita, margem ou resultados de negócio mensuráveis. Sem um modelo financeiro claro desde o primeiro dia, projetos competem por orçamento sem forma de provar seu valor — e perdem toda vez que orçamentos são cortados.',

  // Stall card 4
  'svc.stall4.title': 'Lacunas de Capacidade & Adoção',
  'svc.stall4.desc': 'Execução técnica sem gestão de mudança, estruturas de governança ou estratégia de adoção pelos usuários. Organizações investem em modelos e infraestrutura mas esquecem que IA só gera valor quando pessoas realmente a usam — e quando a organização está estruturada para sustentá-la.',

  // ── MethodologyPipeline (Home page) ────────────────────────────────
  'meth.label': 'Nossa Metodologia',
  'meth.headline': 'Um caminho estruturado do {em}caos de dados{/em} à IA que conquista seu lugar no P&L.',
  'meth.sub': 'O PERCEPTYA AI VALUE SYSTEM™ não é um framework que adaptamos — é uma metodologia construída com um único propósito: capturar valor econômico real da IA em produção.',
  'meth.ph1Badge': 'FASE 1',
  'meth.ph1Label': 'AI Value Discovery',
  'meth.ph1Dur': '6–10 Semanas · Escopo Fixo',
  'meth.ph2Badge': 'FASE 2',
  'meth.ph2Label': 'Industrialização de IA & Captura de Valor',
  'meth.ph2Dur': 'Modular · 3–12+ Meses',
  'meth.cta': 'Explore a metodologia completa',
  'meth.explorePhase': 'Explore esta fase em detalhe',
  'meth.exploreModule': 'Explore este módulo em detalhe',
  'meth.deliverableCaption': 'Exemplo de entregável',
  // Node labels
  'meth.p1n1.label': 'Alinhamento Executivo & Ambição',
  'meth.p1n2.label': 'Avaliação de Maturidade de IA & Dados',
  'meth.p1n3.label': 'Identificação & Priorização de Casos de Uso',
  'meth.p1n4.label': 'Arquitetura-Alvo & Roadmap',
  'meth.p2na.label': 'Modernização da Fundação de Dados',
  'meth.p2nb.label': 'Implementação de Casos de Uso Prioritários',
  'meth.p2nc.label': 'Deploy de Arquitetura de Agentes',
  'meth.p2nd.label': 'Modelo Operacional de IA & Governança',
  'meth.p2ne.label': 'ROI & Rastreamento de Valor',
  // Panel phase tags
  'meth.p1n1.phaseTag': 'Fase 1 · Passo 01',
  'meth.p1n2.phaseTag': 'Fase 1 · Passo 02',
  'meth.p1n3.phaseTag': 'Fase 1 · Passo 03',
  'meth.p1n4.phaseTag': 'Fase 1 · Passo 04',
  'meth.p2na.phaseTag': 'Fase 2 · Módulo A',
  'meth.p2nb.phaseTag': 'Fase 2 · Módulo B',
  'meth.p2nc.phaseTag': 'Fase 2 · Módulo C',
  'meth.p2nd.phaseTag': 'Fase 2 · Módulo D',
  'meth.p2ne.phaseTag': 'Fase 2 · Módulo E',
  // Panel CTA texts
  'meth.p1n1.cta': 'Semana 1 do Discovery. O ponto de partida para toda transformação que entrega resultados reais.',
  'meth.p1n2.cta': 'Semanas 2–4. O benchmark que torna toda decisão futura defensável.',
  'meth.p1n3.cta': 'Semanas 4–6. De 23 candidatos a um portfólio de 7 casos de uso com business cases aprovados.',
  'meth.p1n4.cta': 'Semanas 6–10. A entrega que transforma IA em linha de receita, não em linha de custo.',
  'meth.p2na.cta': 'Módulo A. A fundação que habilita todos os outros módulos. Sem ela, IA não escala.',
  'meth.p2nb.cta': 'Módulo B. IA que entrega resultados desde o primeiro sprint — com números para defender ao conselho.',
  'meth.p2nc.cta': 'Módulo C. Agentes construídos para operar — não para impressionar em demos.',
  'meth.p2nd.cta': 'Módulo D. Sem governança, IA se torna um passivo. Com ela, uma vantagem competitiva.',
  'meth.p2ne.cta': 'Módulo E. O único módulo que roda em paralelo com todos os outros — do primeiro ao último dia.',
  // Panel "What You Get" values
  'meth.p1n1.valueTitle': 'Clareza executiva antes de uma única linha de código.',
  'meth.p1n1.valueDesc': 'Saiba exatamente onde a IA pode mover seu P&L — não aspirações vagas, mas um mandato focado que impulsiona cada decisão do Discovery.',
  'meth.p1n2.valueTitle': 'Um diagnóstico honesto — não um discurso de vendas.',
  'meth.p1n2.valueDesc': 'Seu AI Maturity Score se torna o mapa que todo futuro investimento em dados e IA seguirá.',
  'meth.p1n3.valueTitle': 'Uma lista ranqueada de apostas de IA por impacto econômico real',
  'meth.p1n3.valueDesc': '— não o que é tecnicamente interessante, mas o que realmente move o ponteiro do seu negócio.',
  'meth.p1n4.valueTitle': 'Um plano pronto para o conselho com os números por trás.',
  'meth.p1n4.valueDesc': 'Sua equipe sabe exatamente o que construir, em que ordem, e quais retornos esperar — pronto para aprovação executiva.',
  'meth.p2na.valueTitle': 'IA que funciona exige dados que fluem.',
  'meth.p2na.valueDesc': 'Construímos a fundação da qual todo caso de uso depende — confiável, rastreável e pronta para escalar.',
  'meth.p2nb.valueTitle': 'Não demos. Sistemas em produção.',
  'meth.p2nb.valueDesc': 'Ganhos de receita, margem e eficiência que você pode medir e reportar ao conselho — a cada sprint.',
  'meth.p2nc.valueTitle': 'Automação inteligente que opera em escala.',
  'meth.p2nc.valueDesc': 'Agentes que tomam decisões, executam workflows e atendem clientes — sem gargalos humanos, com rastreabilidade total.',
  'meth.p2nd.valueTitle': 'IA que não é bloqueada pela organização.',
  'meth.p2nd.valueDesc': 'Governança desenhada para acelerar — não para criar burocracia. Sua equipe sabe quem decide, quem executa e quem é responsável.',
  'meth.p2ne.valueTitle': 'Prova. Cada iniciativa vinculada a um número.',
  'meth.p2ne.valueDesc': 'Aumento de receita, redução de custos, ganho de produtividade — rastreados, atribuídos e reportáveis. Sem achismo.',
} as const;

export const servicesES = {
  // ── Services Hero ──────────────────────────────────────────────────
  'svc.heroLabel': 'PERCEPTYA AI VALUE SYSTEM™',
  'svc.heroHeadline': 'De la {em}ambición{/em} de IA al {em}valor{/em} de IA.',
  'svc.heroSub': 'Una metodología estructurada en dos fases, diseñada para organizaciones comprometidas con capturar valor económico de la IA. No ejecutamos pilotos — construimos la base, priorizamos por impacto e industrializamos en sistemas de grado productivo que entregan resultados medibles.',
  'svc.heroBadge1': 'Fase 1 · AI Value Discovery · 6–10 Semanas',
  'svc.heroBadge2': 'Fase 2 · Industrialización de IA · 3–12+ Meses',

  // ── Phase 1 Section ────────────────────────────────────────────────
  'svc.p1Label': 'Fase 1',
  'svc.p1Headline': '{em}AI Value Discovery{/em}',
  'svc.p1Sub': '6–10 semanas de compromiso estructurado que entrega claridad ejecutiva, un portafolio priorizado de casos de uso, blueprint de arquitectura y un roadmap listo para la junta respaldado por modelado económico. Toda transformación comienza aquí.',

  // Phase 1 steps (timeline)
  'svc.p1s1.title': 'Alineamiento Ejecutivo & Ambición',
  'svc.p1s1.timing': 'Semana 1',
  'svc.p1s2.title': 'Evaluación de Madurez de IA & Datos',
  'svc.p1s2.timing': 'Semanas 2–4',
  'svc.p1s3.title': 'Identificación & Priorización de Casos de Uso',
  'svc.p1s3.timing': 'Semanas 4–6',
  'svc.p1s4.title': 'Arquitectura Objetivo & Roadmap',
  'svc.p1s4.timing': 'Semanas 6–10',

  // Phase 1 bundle
  'svc.p1BundleLabel': 'Paquete de Entregables del Discovery',
  'svc.p1BundleTag1': 'AI Maturity Score',
  'svc.p1BundleTag2': 'Portafolio de Casos de Uso',
  'svc.p1BundleTag3': 'Architecture Blueprint',
  'svc.p1BundleTag4': 'Roadmap 18–36 Meses',
  'svc.p1BundleTag5': 'Financial Impact Model',

  // ── Common Frame Tags ──────────────────────────────────────────────
  'svc.frameInputs': 'Entradas',
  'svc.frameActivities': 'Actividades Principales',
  'svc.frameDeliverables': 'Entregables Principales',
  'svc.frameWhatYouGet': 'Lo Que Obtiene',
  'svc.frameInputsRequired': 'Entradas Requeridas',

  // ── Step 01 Detail — Alineamiento Ejecutivo & Ambición ─────────────
  'svc.p1s1.tag': 'Paso 01 · Semana 1',
  'svc.p1s1.input1': 'C-level y líderes de negocio disponibles para workshops',
  'svc.p1s1.input2': 'Visión general de los principales desafíos de negocio y prioridades estratégicas',
  'svc.p1s1.input3': 'Inventario de iniciativas de IA y datos en curso',
  'svc.p1s1.input4': 'Prioridades estratégicas para los próximos 18–36 meses',
  'svc.p1s1.act1': 'Talleres de alineamiento ejecutivo con stakeholders C-level',
  'svc.p1s1.act2': 'Mapeo de pools de valor en todas las áreas de negocio',
  'svc.p1s1.act3': 'Definición de métricas objetivo y KPIs vinculados al P&L',
  'svc.p1s1.act4': 'Establecimiento de principios de gobernanza para iniciativas de IA',
  'svc.p1s1.del1': 'AI Ambition Statement alineado a la estrategia corporativa',
  'svc.p1s1.del2': 'Value Pools Map por área de negocio y función',
  'svc.p1s1.del3': 'Target Metrics Framework con benchmarks de línea base',
  'svc.p1s1.del4': 'Principios de Gobernanza para decisiones de IA',
  'svc.p1s1.value': 'Claridad ejecutiva antes de una sola línea de código.',
  'svc.p1s1.valueDesc': 'Su liderazgo se alinea exactamente en dónde la IA puede mover el P&L — no aspiraciones vagas, sino un mandato enfocado que impulsa cada decisión del Discovery.',

  // ── Step 02 Detail — Evaluación de Madurez de IA & Datos ───────────
  'svc.p1s2.tag': 'Paso 02 · Semanas 2–4',
  'svc.p1s2.input1': 'Acceso a sistemas de datos, stack técnico e infraestructura',
  'svc.p1s2.input2': 'Líderes de los equipos de datos, ingeniería y analytics',
  'svc.p1s2.input3': 'Documentación de arquitectura existente y diccionarios de datos',
  'svc.p1s2.input4': 'Historial de iniciativas pasadas de datos e IA y sus resultados',
  'svc.p1s2.act1': 'Evaluación técnica integral de datos e infraestructura',
  'svc.p1s2.act2': 'Entrevistas de capacidad con equipos de datos, ML e ingeniería',
  'svc.p1s2.act3': 'Auditoría de calidad de datos y evaluación de madurez de gobernanza',
  'svc.p1s2.act4': 'Análisis de brechas en 5 dimensiones de madurez con puntuación',
  'svc.p1s2.del1': 'AI Maturity Score™ (0–5.0 por dimensión)',
  'svc.p1s2.del2': 'Reporte de Análisis de Brechas con prioridades de remediación',
  'svc.p1s2.del3': 'Mapa de Capacidades entre equipos y funciones',
  'svc.p1s2.del4': 'Puntos de Dolor Priorizados vinculados al impacto en el negocio',
  'svc.p1s2.value': 'Un diagnóstico honesto — no un discurso de ventas.',
  'svc.p1s2.valueDesc': 'Su AI Maturity Score se convierte en la línea base definitiva que toda futura decisión de inversión en datos e IA referenciará.',

  // ── Step 03 Detail — Identificación & Priorización de Casos de Uso ─
  'svc.p1s3.tag': 'Paso 03 · Semanas 4–6',
  'svc.p1s3.input1': 'Resultados del AI Maturity Score y análisis de brechas',
  'svc.p1s3.input2': 'Líderes de unidades de negocio de ingresos y operaciones',
  'svc.p1s3.input3': 'Datos de P&L por proceso, departamento y área de negocio',
  'svc.p1s3.input4': 'Benchmarks de adopción de IA en la industria e inteligencia competitiva',
  'svc.p1s3.act1': 'Talleres multifuncionales de ideación de casos de uso',
  'svc.p1s3.act2': 'Modelado de impacto financiero por caso de uso candidato',
  'svc.p1s3.act3': 'Evaluación de viabilidad técnica y preparación de datos',
  'svc.p1s3.act4': 'Clasificación de quick wins vs. apuestas estratégicas',
  'svc.p1s3.del1': 'Portafolio Completo de Casos de Uso (20–30 candidatos identificados)',
  'svc.p1s3.del2': 'Matriz de Priorización Impacto × Viabilidad',
  'svc.p1s3.del3': 'Business Cases Detallados para los Top 5–10 casos de uso',
  'svc.p1s3.del4': 'Roadmap de Quick Wins para captura inmediata de valor',
  'svc.p1s3.value': 'Un portafolio ranqueado de apuestas de IA por impacto económico real',
  'svc.p1s3.valueDesc': '— no lo que es técnicamente interesante, sino lo que realmente mueve la aguja de su negocio.',

  // ── Step 04 Detail — Arquitectura Objetivo & Roadmap ───────────────
  'svc.p1s4.tag': 'Paso 04 · Semanas 6–10',
  'svc.p1s4.input1': 'Casos de uso priorizados con business cases validados',
  'svc.p1s4.input2': 'Stack tecnológico actual y panorama de infraestructura',
  'svc.p1s4.input3': 'Parámetros de presupuesto y apetito de inversión',
  'svc.p1s4.input4': 'Restricciones regulatorias, de compliance y seguridad',
  'svc.p1s4.act1': 'Diseño de arquitectura objetivo en capas de datos, ML e IA',
  'svc.p1s4.act2': 'Evaluación de tecnología, selección y mapeo de proveedores',
  'svc.p1s4.act3': 'Secuenciamiento de fases con análisis de dependencias y riesgos',
  'svc.p1s4.act4': 'Modelado de inversión vs. retorno a lo largo de 18–36 meses',
  'svc.p1s4.del1': 'Architecture Blueprint (capas de datos + IA + agentes)',
  'svc.p1s4.del2': 'Roadmap de 18–36 Meses — secuenciado, costeado, listo para la junta',
  'svc.p1s4.del3': 'Modelo de Impacto Financiero con proyecciones de ROI',
  'svc.p1s4.del4': 'Plan de Industrialización para ejecución de la Fase 2',
  'svc.p1s4.value': 'Un plan listo para la junta con los números detrás.',
  'svc.p1s4.valueDesc': 'Su equipo sabe exactamente qué construir, en qué orden, y qué retornos esperar — listo para aprobación ejecutiva.',

  // ── Phase 2 Section ────────────────────────────────────────────────
  'svc.p2Label': 'Fase 2',
  'svc.p2Headline': '{em}Industrialización de IA{/em} & Captura de Valor',
  'svc.p2Sub': 'Ejecución modular en 5 frentes de trabajo, secuenciada por los hallazgos del Discovery. Cada módulo está diseñado para producción desde el primer día — con gobernanza, monitoreo, adopción y seguimiento continuo de ROI integrados.',

  // Phase 2 module titles & timings
  'svc.p2sa.title': 'Modernización de la Base de Datos',
  'svc.p2sa.timing': 'Lakehouse · Pipelines · Gobernanza',
  'svc.p2sb.title': 'Implementación de Casos de Uso Prioritarios',
  'svc.p2sb.timing': 'MLOps · Producción · Adopción',
  'svc.p2sc.title': 'Despliegue de Arquitectura de Agentes',
  'svc.p2sc.timing': 'Orquestación · Guardrails · Integración',
  'svc.p2sd.title': 'Modelo Operativo de IA & Gobernanza',
  'svc.p2sd.timing': 'CoE · RACI · Políticas · Compliance',
  'svc.p2se.title': 'ROI & Seguimiento de Valor',
  'svc.p2se.timing': 'Dashboards · Scorecards · Evidencia',

  // ── Module A Detail — Modernización de la Base de Datos ────────────
  'svc.p2sa.tag': 'Módulo A',
  'svc.p2sa.input1': 'Architecture Blueprint de la fase de Discovery',
  'svc.p2sa.input2': 'Inventario actual de infraestructura de datos y credenciales de acceso',
  'svc.p2sa.input3': 'Hallazgos de calidad de datos de la Evaluación de Madurez de IA',
  'svc.p2sa.input4': 'Requisitos regulatorios y de compliance para datos',
  'svc.p2sa.act1': 'Diseño e implementación de arquitectura lakehouse',
  'svc.p2sa.act2': 'Ingeniería de pipelines de datos y configuración de orquestación',
  'svc.p2sa.act3': 'Implementación del framework de gobernanza de datos con reglas de calidad',
  'svc.p2sa.act4': 'Implementación de gestión de datos maestros y catalogación',
  'svc.p2sa.del1': 'Plataforma de data lakehouse lista para producción',
  'svc.p2sa.del2': 'Pipelines de datos automatizados con monitoreo y alertas',
  'svc.p2sa.del3': 'Framework de gobernanza de datos con scorecards de calidad',
  'svc.p2sa.del4': 'Catálogo de datos con linaje y controles de acceso',
  'svc.p2sa.value': 'Una base de datos gobernada que hace posible la IA.',
  'svc.p2sa.valueDesc': 'Sus datos se convierten en un activo confiable y accesible — la base de la cual cada modelo de IA, agente y sistema de analytics depende.',

  // ── Module B Detail — Implementación de Casos de Uso Prioritarios ──
  'svc.p2sb.tag': 'Módulo B',
  'svc.p2sb.input1': 'Casos de uso priorizados con business cases validados del Discovery',
  'svc.p2sb.input2': 'Base de datos y pipelines del Módulo A',
  'svc.p2sb.input3': 'Expertos de dominio y stakeholders de negocio para validación',
  'svc.p2sb.input4': 'Criterios de aceptación del usuario y métricas de éxito',
  'svc.p2sb.act1': 'Desarrollo, entrenamiento y ciclos de validación de modelos de ML',
  'svc.p2sb.act2': 'Configuración de pipeline MLOps para CI/CD y versionado de modelos',
  'svc.p2sb.act3': 'Despliegue en producción con monitoreo y detección de drift',
  'svc.p2sb.act4': 'Programas de adopción por usuarios con capacitación y ciclos de feedback',
  'svc.p2sb.del1': 'Modelos de IA en producción con garantías de SLA',
  'svc.p2sb.del2': 'Plataforma MLOps con pipelines de reentrenamiento automatizado',
  'svc.p2sb.del3': 'Dashboards de monitoreo de modelos con alertas de drift y rendimiento',
  'svc.p2sb.del4': 'Playbook de adopción por usuarios con materiales de capacitación',
  'svc.p2sb.value': 'IA en producción — no en un notebook.',
  'svc.p2sb.valueDesc': 'Sus casos de uso de mayor impacto entran en producción con confiabilidad enterprise, monitoreo y adopción integrados desde el primer día.',

  // ── Module C Detail — Despliegue de Arquitectura de Agentes ────────
  'svc.p2sc.tag': 'Módulo C',
  'svc.p2sc.input1': 'Requisitos de casos de uso que demandan IA autónoma o semi-autónoma',
  'svc.p2sc.input2': 'Sistemas enterprise y APIs para integración de agentes',
  'svc.p2sc.input3': 'Políticas de seguridad y requisitos de guardrails',
  'svc.p2sc.input4': 'Workflows de usuarios y protocolos de escalamiento',
  'svc.p2sc.act1': 'Diseño e implementación del framework de orquestación de agentes',
  'svc.p2sc.act2': 'Sistemas de guardrails con límites de seguridad y fallbacks',
  'svc.p2sc.act3': 'Integración con sistemas enterprise y conectividad de APIs',
  'svc.p2sc.act4': 'Workflows de human-in-the-loop y diseño de escalamiento',
  'svc.p2sc.del1': 'Agentes de IA desplegados con capa de orquestación',
  'svc.p2sc.del2': 'Framework de guardrails con documentación de pruebas de seguridad',
  'svc.p2sc.del3': 'Conectores de integración con sistemas enterprise',
  'svc.p2sc.del4': 'Protocolos de escalamiento y dashboards de supervisión humana',
  'svc.p2sc.value': 'Agentes de IA que actúan — dentro de límites seguros y gobernados.',
  'svc.p2sc.valueDesc': 'Su organización despliega IA autónoma con los guardrails, integraciones y supervisión humana que las operaciones enterprise exigen.',

  // ── Module D Detail — Modelo Operativo de IA & Gobernanza ──────────
  'svc.p2sd.tag': 'Módulo D',
  'svc.p2sd.input1': 'Principios de gobernanza de la fase de Discovery',
  'svc.p2sd.input2': 'Estructura organizacional y capacidades existentes de CoE',
  'svc.p2sd.input3': 'Panorama regulatorio y requisitos de compliance',
  'svc.p2sd.input4': 'Framework de gestión de riesgos y requisitos de auditoría',
  'svc.p2sd.act1': 'Diseño del Centro de Excelencia de IA y estructuración de equipo',
  'svc.p2sd.act2': 'Matrices RACI y frameworks de responsabilidad para iniciativas de IA',
  'svc.p2sd.act3': 'Desarrollo de políticas de IA cubriendo ética, sesgo y transparencia',
  'svc.p2sd.act4': 'Integración de compliance con procesos regulatorios y de auditoría',
  'svc.p2sd.del1': 'Framework operativo del Centro de Excelencia de IA',
  'svc.p2sd.del2': 'Matrices RACI para todas las iniciativas y frentes de trabajo de IA',
  'svc.p2sd.del3': 'Manual de políticas de IA cubriendo ética, riesgo y compliance',
  'svc.p2sd.del4': 'Documentación lista para auditoría y checklists de compliance',
  'svc.p2sd.value': 'El músculo organizacional para sostener IA a escala.',
  'svc.p2sd.valueDesc': 'Su programa de IA tiene las estructuras de gobernanza, responsabilidad y compliance que transforman proyectos individuales en una capacidad enterprise duradera.',

  // ── Module E Detail — ROI & Seguimiento de Valor ───────────────────
  'svc.p2se.tag': 'Módulo E',
  'svc.p2se.input1': 'Modelo de Impacto Financiero de la fase de Discovery',
  'svc.p2se.input2': 'Sistemas de IA en producción con datos de telemetría',
  'svc.p2se.input3': 'KPIs de negocio y benchmarks de línea base',
  'svc.p2se.input4': 'Requisitos y cadencias de reporte para stakeholders',
  'svc.p2se.act1': 'Diseño de dashboard de ROI e integración de datos',
  'svc.p2se.act2': 'Desarrollo de scorecards de valor por caso de uso y unidad de negocio',
  'svc.p2se.act3': 'Framework de reporte basado en evidencia para revisiones ejecutivas',
  'svc.p2se.act4': 'Ciclos de mejora continua impulsados por datos de valor',
  'svc.p2se.del1': 'Dashboards de ROI en vivo con seguimiento de valor en tiempo real',
  'svc.p2se.del2': 'Scorecards de valor por caso de uso con senderos de evidencia',
  'svc.p2se.del3': 'Paquete de reporte ejecutivo con resúmenes listos para la junta',
  'svc.p2se.del4': 'Recomendaciones de mejora continua basadas en datos de valor',
  'svc.p2se.value': 'Prueba de que la IA entrega — en números, no en narrativas.',
  'svc.p2se.valueDesc': 'Cada inversión en IA es rastreada, medida y reportada con el rigor que su junta y stakeholders esperan.',

  // ── Phase 2 Bundle ─────────────────────────────────────────────────
  'svc.p2BundleLabel': 'Resultados de la Industrialización',
  'svc.p2BundleTag1': 'Sistemas de IA en Producción',
  'svc.p2BundleTag2': 'Despliegue de Agentes',
  'svc.p2BundleTag3': 'Plataforma de Datos Gobernada',
  'svc.p2BundleTag4': 'Dashboards de ROI',
  'svc.p2BundleTag5': 'Modelo Operativo',

  // ── Engagement Model Section ───────────────────────────────────────
  'svc.engLabel': 'Cómo Trabajamos',
  'svc.engHeadline': 'Tres formas de trabajar con nosotros.',
  'svc.engSub': 'Cada compromiso está estructurado para claridad, responsabilidad y resultados medibles. Elija el modelo que se ajusta a su etapa.',

  // Engagement 1 — AI Value Discovery
  'svc.eng1Badge': 'AI Value Discovery',
  'svc.eng1Title': 'Claridad Ejecutiva',
  'svc.eng1Body': 'Alcance fijo, 6–10 semanas. El punto de partida para cada compromiso. Entrega AI Maturity Score, casos de uso priorizados, blueprint de arquitectura y un roadmap listo para la junta con modelo de impacto financiero.',
  'svc.eng1Meta1': 'Alcance Fijo',
  'svc.eng1Meta2': '6–10 Semanas',
  'svc.eng1Meta3': '5 Entregables',

  // Engagement 2 — AI Industrialization
  'svc.eng2Badge': 'Industrialización de IA',
  'svc.eng2Title': 'IA en Producción',
  'svc.eng2Body': 'Ejecución modular, 3–12+ meses. Secuenciada por los hallazgos del Discovery. Base de datos, implementación de casos de uso, arquitectura de agentes, gobernanza y seguimiento de ROI — todo construido para producción.',
  'svc.eng2Meta1': 'Modular',
  'svc.eng2Meta2': '3–12+ Meses',
  'svc.eng2Meta3': 'Listo para Producción',

  // Engagement 3 — Dedicated PODs
  'svc.eng3Badge': 'PODs Dedicados',
  'svc.eng3Title': 'Escala & Velocidad',
  'svc.eng3Body': 'PODs dedicados. Senior, alineados por zona horaria, tech-agnostic. Compromiso mensual diseñado para organizaciones que necesitan capacidad de ejecución sostenida y talento de ingeniería de IA integrado.',
  'svc.eng3Meta1': 'Onshore y Nearshore',
  'svc.eng3Meta2': 'Mensual',
  'svc.eng3Meta3': 'PODs Senior',

  'svc.engCta': 'Comience con AI Value Discovery',

  // ── Why AI Stalls Section ──────────────────────────────────────────
  'svc.stallLabel': 'Por Qué las Iniciativas de IA se Estancan',
  'svc.stallHeadline': 'La mayoría de las organizaciones tienen la {em}ambición{/em}. Pocas tienen la {em}base{/em}.',
  'svc.stallSub': 'El desafío no es el acceso a herramientas de IA — es lo que viene antes. Las investigaciones muestran consistentemente las mismas cuatro causas raíz que bloquean la IA empresarial de entregar valor. Construimos nuestra metodología para resolver cada una.',

  // Stall card column labels
  'svc.stallImplications': 'Implicaciones para el Negocio',
  'svc.stallLooksLike': 'Cómo Se Manifiesta',
  'svc.stallResearch': 'Investigación',

  // Stall card 1
  'svc.stall1.title': 'Datos Fragmentados',
  'svc.stall1.desc': 'Sistemas aislados, sin fuente única de verdad, y problemas de calidad de datos que bloquean la IA en cada paso. Cuando los modelos de IA entrenan con datos inconsistentes, incompletos o no gobernados, los resultados no son confiables — y los ejecutivos pierden confianza en todo el programa.',

  // Stall card 2
  'svc.stall2.title': 'Pilotos Que Nunca Escalan',
  'svc.stall2.desc': 'POCs que demuestran un punto pero nunca llegan a producción. Las organizaciones lanzan pruebas de concepto en sandboxes seguros, pero los desafíos de integración, gobernanza, MLOps y adopción por los usuarios significan que se estancan en la etapa de demo — para siempre.',

  // Stall card 3
  'svc.stall3.title': 'Sin Tesis Económica',
  'svc.stall3.desc': 'Iniciativas de IA desconectadas de ingresos, margen o resultados de negocio medibles. Sin un modelo financiero claro desde el primer día, los proyectos compiten por presupuesto sin forma de probar su valor — y pierden cada vez que los presupuestos se ajustan.',

  // Stall card 4
  'svc.stall4.title': 'Brechas de Capacidad & Adopción',
  'svc.stall4.desc': 'Ejecución técnica sin gestión del cambio, estructuras de gobernanza o estrategia de adopción por los usuarios. Las organizaciones invierten en modelos e infraestructura pero olvidan que la IA solo genera valor cuando las personas realmente la usan — y cuando la organización está estructurada para sostenerla.',

  // ── MethodologyPipeline (Home page) ────────────────────────────────
  'meth.label': 'Nuestra Metodología',
  'meth.headline': 'Un camino estructurado del {em}caos de datos{/em} a IA que se gana su lugar en el P&L.',
  'meth.sub': 'El PERCEPTYA AI VALUE SYSTEM™ no es un framework que adaptamos — es una metodología construida con un único propósito: capturar valor económico real de la IA en producción.',
  'meth.ph1Badge': 'FASE 1',
  'meth.ph1Label': 'AI Value Discovery',
  'meth.ph1Dur': '6–10 Semanas · Alcance Fijo',
  'meth.ph2Badge': 'FASE 2',
  'meth.ph2Label': 'Industrialización de IA & Captura de Valor',
  'meth.ph2Dur': 'Modular · 3–12+ Meses',
  'meth.cta': 'Explore la metodología completa',
  'meth.explorePhase': 'Explore esta fase en detalle',
  'meth.exploreModule': 'Explore este módulo en detalle',
  'meth.deliverableCaption': 'Ejemplo de entregable',
  // Node labels
  'meth.p1n1.label': 'Alineamiento Ejecutivo & Ambición',
  'meth.p1n2.label': 'Evaluación de Madurez de IA & Datos',
  'meth.p1n3.label': 'Identificación & Priorización de Casos de Uso',
  'meth.p1n4.label': 'Arquitectura Objetivo & Roadmap',
  'meth.p2na.label': 'Modernización de la Fundación de Datos',
  'meth.p2nb.label': 'Implementación de Casos de Uso Prioritarios',
  'meth.p2nc.label': 'Despliegue de Arquitectura de Agentes',
  'meth.p2nd.label': 'Modelo Operativo de IA & Gobernanza',
  'meth.p2ne.label': 'ROI & Seguimiento de Valor',
  // Panel phase tags
  'meth.p1n1.phaseTag': 'Fase 1 · Paso 01',
  'meth.p1n2.phaseTag': 'Fase 1 · Paso 02',
  'meth.p1n3.phaseTag': 'Fase 1 · Paso 03',
  'meth.p1n4.phaseTag': 'Fase 1 · Paso 04',
  'meth.p2na.phaseTag': 'Fase 2 · Módulo A',
  'meth.p2nb.phaseTag': 'Fase 2 · Módulo B',
  'meth.p2nc.phaseTag': 'Fase 2 · Módulo C',
  'meth.p2nd.phaseTag': 'Fase 2 · Módulo D',
  'meth.p2ne.phaseTag': 'Fase 2 · Módulo E',
  // Panel CTA texts
  'meth.p1n1.cta': 'Semana 1 del Discovery. El punto de partida para toda transformación que entrega resultados reales.',
  'meth.p1n2.cta': 'Semanas 2–4. El benchmark que hace toda decisión futura defendible.',
  'meth.p1n3.cta': 'Semanas 4–6. De 23 candidatos a un portafolio de 7 casos de uso con business cases aprobados.',
  'meth.p1n4.cta': 'Semanas 6–10. El entregable que transforma IA en línea de ingresos, no en línea de costos.',
  'meth.p2na.cta': 'Módulo A. La fundación que habilita todos los demás módulos. Sin ella, la IA no escala.',
  'meth.p2nb.cta': 'Módulo B. IA que entrega resultados desde el primer sprint — con números para defender ante el directorio.',
  'meth.p2nc.cta': 'Módulo C. Agentes construidos para operar — no para impresionar en demos.',
  'meth.p2nd.cta': 'Módulo D. Sin gobernanza, la IA se convierte en un pasivo. Con ella, una ventaja competitiva.',
  'meth.p2ne.cta': 'Módulo E. El único módulo que corre en paralelo con todos los demás — del primer al último día.',
  // Panel "What You Get" values
  'meth.p1n1.valueTitle': 'Claridad ejecutiva antes de una sola línea de código.',
  'meth.p1n1.valueDesc': 'Sepa exactamente dónde la IA puede mover su P&L — no aspiraciones vagas, sino un mandato enfocado que impulsa cada decisión del Discovery.',
  'meth.p1n2.valueTitle': 'Un diagnóstico honesto — no un discurso de ventas.',
  'meth.p1n2.valueDesc': 'Su AI Maturity Score se convierte en el mapa que toda futura inversión en datos e IA seguirá.',
  'meth.p1n3.valueTitle': 'Una lista ranqueada de apuestas de IA por impacto económico real',
  'meth.p1n3.valueDesc': '— no lo que es técnicamente interesante, sino lo que realmente mueve la aguja de su negocio.',
  'meth.p1n4.valueTitle': 'Un plan listo para el directorio con los números detrás.',
  'meth.p1n4.valueDesc': 'Su equipo sabe exactamente qué construir, en qué orden, y qué retornos esperar — listo para aprobación ejecutiva.',
  'meth.p2na.valueTitle': 'La IA que funciona requiere datos que fluyen.',
  'meth.p2na.valueDesc': 'Construimos la fundación de la que depende cada caso de uso — confiable, rastreable y lista para escalar.',
  'meth.p2nb.valueTitle': 'No demos. Sistemas en producción.',
  'meth.p2nb.valueDesc': 'Ganancias de ingresos, margen y eficiencia que puede medir y reportar al directorio — cada sprint.',
  'meth.p2nc.valueTitle': 'Automatización inteligente que opera a escala.',
  'meth.p2nc.valueDesc': 'Agentes que toman decisiones, ejecutan workflows y atienden clientes — sin cuellos de botella humanos, con trazabilidad total.',
  'meth.p2nd.valueTitle': 'IA que no es bloqueada por la organización.',
  'meth.p2nd.valueDesc': 'Gobernanza diseñada para acelerar — no para crear burocracia. Su equipo sabe quién decide, quién ejecuta y quién es responsable.',
  'meth.p2ne.valueTitle': 'Prueba. Cada iniciativa vinculada a un número.',
  'meth.p2ne.valueDesc': 'Aumento de ingresos, reducción de costos, ganancia de productividad — rastreados, atribuidos y reportables. Sin conjeturas.',
} as const;
